(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["echo-header"]) return;
  try {
    
  // Initialize thumbnail preview slider
  var thumbnailSlider = new Swiper('.thumbnail-preview', {
    spaceBetween: 10,
    slidesPerView: 4,
    freeMode: true,
    watchSlidesProgress: true,
  });

  // Initialize main gallery slider with thumbnail navigation
  var mainSlider = new Swiper('.main-slider', {
    thumbs: {
      swiper: thumbnailSlider,
    },
    // autoplay: {
    //   delay: 5000,
    //   pauseOnMouseEnter: true,
    // },
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index-header"] && !Shopify.designMode) return;
  try {
    
  var swiper = new Swiper('.headerSlider', {
    mousewheel: {
      enabled: true,
      forceToAxis: true,
    },
    effect: 'fade',
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    loop: true,
    autoplay: {
      delay: 6000,
    },
    speed: 800,
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index-showcase"]) return;
  try {
    
  const showcaseSlider = new Swiper('.showcaseSlider', {
    mousewheel: {
      enabled: true,
      forceToAxis: true,
      sensitivity: 0.35,
      thresholdDelta: 15,
    },
    slidesPerView: 1.1,
    spaceBetween: 16,
    loop: false,
    navigation: {
      nextEl: '.swiper-next',
      prevEl: '.swiper-prev',
    },

    breakpoints: {
      1024: {
        slidesPerView: 'auto',
        spaceBetween: 40,
      },
    },
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["navbar"]) return;
  try {
    
  // Hide navbar on mobile
  if (window.innerWidth < 768) {
    const navbar = document.getElementById('navbar');

    let lastScrollY = window.scrollY;

    window.addEventListener(
      'scroll',
      () => {
        const currentScrollY = window.scrollY;

        if (Math.abs(currentScrollY - lastScrollY) < 10) return;

        if (currentScrollY > lastScrollY && currentScrollY > 80) {
          navbar.classList.add('-translate-y-full');
        } else {
          navbar.classList.remove('-translate-y-full');
        }

        lastScrollY = currentScrollY;
      },
      { passive: true },
    );
  }

  // Mobile menu toggle
  window.addEventListener('DOMContentLoaded', () => {
    const mobileMenu = document.getElementById('mobile-menu');
    const mobileMenuBtn = document.getElementById('mobile-menu-button');
    const iconHamburger = document.getElementById('icon-hamburger');
    const iconClose = document.getElementById('icon-close');
    const collectionsToggle = document.getElementById('collections-toggle');
    const collectionsMenu = document.getElementById('collections-dropdown');
    const collectionsChevron = document.getElementById('collections-chevron');
    const scrollTopBtn = document.getElementById('scrollTopBtn');

    let collectionsOpen = false;

    // ── Menu open / close ──────────────────────────────
    function openMenu() {
      mobileMenu.classList.add('active');
      iconHamburger.classList.add('hidden');
      iconClose.classList.remove('hidden');
      document.body.style.overflow = 'hidden';
      scrollTopBtn.classList.add('opacity-0', 'pointer-events-none');
    }

    function closeMenu() {
      mobileMenu.classList.remove('active');
      iconHamburger.classList.remove('hidden');
      iconClose.classList.add('hidden');
      document.body.style.overflow = '';
      if (collectionsOpen) closeCollections();
      scrollTopBtn.classList.remove('opacity-0', 'pointer-events-none');
    }

    mobileMenuBtn.addEventListener('click', () => {
      mobileMenu.classList.contains('active') ? closeMenu() : openMenu();
    });

    // ── Collections dropdown ───────────────────────────
    function openCollections() {
      collectionsOpen = true;
      collectionsMenu.style.maxHeight = collectionsMenu.scrollHeight + 'px';
      collectionsMenu.style.opacity = '1';
      collectionsChevron.style.transform = 'rotate(180deg)';
      collectionsToggle.setAttribute('aria-expanded', 'true');
    }

    function closeCollections() {
      collectionsOpen = false;
      collectionsMenu.style.maxHeight = '0';
      collectionsMenu.style.opacity = '0';
      collectionsChevron.style.transform = '';
      collectionsToggle.setAttribute('aria-expanded', 'false');
    }

    collectionsToggle.addEventListener('click', () => {
      collectionsOpen ? closeCollections() : openCollections();
    });
  });

  // Dropdown collections menu
  const openBtn = document.getElementById('dropdown-button');
  const dropdown = document.getElementById('navbar-dropdown');
  const backdrop = document.getElementById('backdrop');

  function openDialog() {
    dropdown.classList.remove('hidden');
    dropdown.classList.add('block');

    backdrop.classList.remove('hidden');
    backdrop.classList.add('visible');
  }

  function closeDialog() {
    dropdown.classList.add('hidden');
    dropdown.classList.remove('block');

    backdrop.classList.add('hidden');
    backdrop.classList.remove('visible');
  }

  openBtn.addEventListener('click', openDialog);

  backdrop.addEventListener('click', closeDialog);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeDialog();
  });

  // Scroll to top button
  const orderBanner = document.getElementById('order-banner');

  if (orderBanner) {
    scrollTopBtn.classList.remove('md:bottom-10', 'bottom-4');
    scrollTopBtn.classList.add('bottom-[72px]', 'md:bottom-20');
  }

  window.addEventListener('scroll', () => {
    if (window.scrollY > 300) {
      scrollTopBtn.classList.remove('opacity-0', 'pointer-events-none');
    } else {
      scrollTopBtn.classList.add('opacity-0', 'pointer-events-none');
    }
  });

  scrollTopBtn.addEventListener('click', () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["t-bone-gallery"]) return;
  try {
    
  var swiper = new Swiper('.section-about', {
    mousewheel: {
      enabled: true,
      forceToAxis: true,
      sensitivity: 0.35,
      thresholdDelta: 15,
    },
    slidesPerView: 1.2,
    spaceBetween: 16,
    slidesOffsetBefore: 16,
    loop: true,
    autoplay: {
      delay: 4000,
      pauseOnMouseEnter: true,
    },
    breakpoints: {
      1024: {
        slidesPerView: 'auto',
        slidesOffsetBefore: 16,
      },
    },
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["varkhan-gallery"]) return;
  try {
    
  var swiper = new Swiper('.section-gallery', {
    slidesPerView: 'auto',
    centeredSlides: false,
    initialSlide: 1,
    spaceBetween: 16,
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["varkhan-header"] && !Shopify.designMode) return;
  try {
    
  var swiper = new Swiper('.headerSlider', {
    mousewheel: {
      enabled: true,
      forceToAxis: true,
    },
    effect: 'fade',
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    loop: true,
    autoplay: {
      delay: 6000,
    },
    speed: 800,
  });

  } catch(e) { console.error(e); }
})();
})();
